import {
  Controller,
  Get,
  Post,
  Patch,
  Delete,
  Param,
  Body,
  UploadedFile,
  UseInterceptors,
  Res,
  Query,
  BadRequestException,
} from '@nestjs/common';
import { FileInterceptor } from '@nestjs/platform-express';
import { Response } from 'express';
import { AttachmentsService } from './attachments.service';
import { UpdateAttachmentsDto } from '@crm/dto';
import { ApiResponseInterface } from '@crm/interface';

@Controller('attachments')
export class AttachmentsController {
  constructor(private readonly attachmentsService: AttachmentsService) {}

  // ====== UPLOAD FILE ======
  @Post('upload')
  @UseInterceptors(FileInterceptor('file'))
  async upload(
    @UploadedFile() file: Express.Multer.File,
    @Query('bucket') bucket?: string,
  ): Promise<ApiResponseInterface> {
    if (!file) {
      throw new BadRequestException('No file provided.');
    }
    return this.attachmentsService.upload(file, bucket || 'acc-crm');
  }

  // ====== SERVE FILE ======
  @Get('file/:id')
  async serveFile(
    @Param('id') id: string,
    @Res() res: Response,
  ): Promise<void> {
    return this.attachmentsService.serveFile(id, res);
  }

  // ====== GET ALL ATTACHMENTS ======
  @Get()
  async getAll(): Promise<ApiResponseInterface> {
    return this.attachmentsService.getAll();
  }

  // ====== GET ATTACHMENT BY ID ======
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.attachmentsService.getById(id);
  }

  // ====== UPDATE ATTACHMENT ======
  @Patch()
  async update(@Body() dto: UpdateAttachmentsDto): Promise<ApiResponseInterface> {
    return this.attachmentsService.update(dto);
  }

  // ====== SOFT DELETE ATTACHMENT ======
  @Patch('soft-delete')
  async softDelete(@Body() dto: UpdateAttachmentsDto): Promise<ApiResponseInterface> {
    return this.attachmentsService.softDelete(dto);
  }

  // ====== HARD DELETE (removes file from disk) ======
  @Delete(':id')
  async deleteFile(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.attachmentsService.deleteFile(id);
  }
}